import './About.css';
import SideMenu from '../SideMenu';
import SethL from '../../images/SethLROOFI2P.jpg';
import Resume from '../../images/sethLResume.pdf';
import VoicemailIcon from '../../images/Portfolio2VoicemailIcon.png';
import MailIcon from '../../images/Portfolio2MailIcon.png';
import ProfileIcon from '../../images/Portfolio2ProfileIcon.png';
import LocationIcon from '../../images/Portfolio2LocationIcon.png';

function AboutContent() {
  return (
    <div className = 'about-content-content'>
          <div className = 'about-content-content-content'>
            <div className = 'about-content-content-content-intro'>
              <span className = 'about-content-content-content-intro-subtitle'>Nice to meet you!</span>
              <span className = 'about-content-content-content-intro-title'>WELCOME TO...</span>
              <img alt = "Seth LaMar" src = {SethL} className = 'about-content-content-content-intro-img' />
              <span className = 'about-content-content-content-intro-name'>SETH LAMAR</span>
              <span className = 'about-content-content-content-intro-location'><span className = 'about-content-content-content-intro-location-special'>Fullstack Engineer</span> based in <span className = 'about-content-content-content-intro-location-special'>New Jersey</span></span>
              <a href={Resume} className = 'about-content-content-content-intro-resume'>Download CV</a>
            </div>
            <div className = 'about-content-content-content-info'>
              <div className = 'about-content-content-content-info-info'>
                
                <div className = 'about-content-content-content-info-info-group'>
                  <img className = 'about-content-content-content-info-info-group-img' src = {MailIcon} />
                  <span className = 'about-content-content-content-info-info-group-text'>slprogram2005@gmail.com</span>
                </div>
                <div className = 'about-content-content-content-info-info-group'>
                  <img className = 'about-content-content-content-info-info-group-img' src = {ProfileIcon} />
                  <span className = 'about-content-content-content-info-info-group-text'>20 yrs</span>
                </div>
                <div className = 'about-content-content-content-info-info-group'>
                  <img className = 'about-content-content-content-info-info-group-img' src = {LocationIcon} />
                  <span className = 'about-content-content-content-info-info-group-text'>New Jersey, USA</span>
                </div>
              </div>

              <div className = 'about-content-content-content-info-history'>
                <div className = 'about-content-content-content-info-history-category'>
                  <div className = 'about-content-content-content-info-history-category-title'>
                    <span className = 'about-content-content-content-info-history-category-title-special'>1+</span>
                    <span className = 'about-content-content-content-info-history-category-title-text'>Years experience...</span>
                  </div>
                  <div className = 'about-content-content-content-info-history-category-content'>
                    <span className = 'about-content-content-content-info-history-category-content-text'>My strength lies in creating and maintaining responsive and accessible full stack web applications that offer a smooth user experience through clean, optimized code.</span>
                  </div>
                </div>
                <div className = 'about-content-content-content-info-history-category'>
                  <div className = 'about-content-content-content-info-history-category-title'>
                    <span className = 'about-content-content-content-info-history-category-title-special'>5+</span>
                    <span className = 'about-content-content-content-info-history-category-title-text'>Years Programming...</span>
                  </div>
                  <div className = 'about-content-content-content-info-history-category-content'>
                    <span className = 'about-content-content-content-info-history-category-content-text'>I first discovered coding at the age of 15 years old and fell in love, In my early days I began coding creating games and later found interest in web development and started the development course The Odin Project.</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
  );
}

export default AboutContent;